import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectionState } from 'utils/signalr';

const initialState = {
    connectionState: 'initial' as ConnectionState,
};

const signalrSlice = createSlice({
    name: 'signalr',
    initialState,
    reducers: {
        setConnectionState: (state, action: PayloadAction<ConnectionState>) => {
            state.connectionState = action.payload;
        },
    },
});

export const { setConnectionState } = signalrSlice.actions;

export default signalrSlice.reducer;